import { FunctionComponent, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { getPeriodDate } from '../util/FormatDateUtil';
import { CalendarInput } from './CalendarInput';

interface IDateSelectorProps {
  startPeriod: string;
  endPeriod?: string;
  isStartAndEnd?: boolean;
  onChange: (start: string, end: string) => void;
  showMonth: boolean;
  dateFormat: string; // 'yyyy-MM' or 'y-MM-dd'
  inputFormat: string;
  hideSearch?: boolean;
}

const popperModifiers = [
  {
    name: "offset",
    options: {
      offset: [0, -20],
    },
  }
];

export const DateSelector: FunctionComponent<IDateSelectorProps> = (props) => {
    const intl = useIntl();
    const [inputStartValue, setInputStartValue] = useState<string>(props.startPeriod);
    const [selectedStartDay, setSelectedStartDay] = useState(getPeriodDate(props.startPeriod));
    const [inputEndValue, setInputEndValue] = useState<string>(props.endPeriod || "");
    const [selectedEndDay, setSelectedEndDay] = useState(props.endPeriod ? getPeriodDate(props.endPeriod) : undefined);
    const lang = intl.locale;

    const startTextId = props.isStartAndEnd ? 'calendar.select.start' : 'calendar.select.month';

    return (
      <>
        <div className="highlight_bg">
          <div className="d-flex flex-md-row align-items-md-center flex-column">
            <DatePicker
              showPopperArrow={false}
              selected={selectedStartDay}
              onChange={(date) => {
                setSelectedStartDay(date ? date : undefined);
                setInputStartValue(date ? format(date, props.inputFormat) : '');
                if(props.hideSearch) props.onChange(date ? format(date, props.inputFormat) : '', inputEndValue);
              }}
              customInput={<CalendarInput label={startTextId} name="startdate" id="startdate"/>}
              dateFormat={props.dateFormat} // "yyyy-MM-dd"
              showMonthYearPicker={props.showMonth}
              popperModifiers={popperModifiers}
              locale={lang}
            />
            {props.isStartAndEnd &&
              <DatePicker
                showPopperArrow={false}
                selected={selectedEndDay}
                onChange={(date) => {
                  setSelectedEndDay(date ? date : undefined);
                  setInputEndValue(date ? format(date, props.inputFormat) : '');
                  if(props.hideSearch) props.onChange(inputStartValue, date ? format(date, props.inputFormat) : '');
                }}
                customInput={<CalendarInput label="calendar.select.end" name="enddate" id="enddate"/>}
                dateFormat={props.dateFormat}
                showMonthYearPicker={props.showMonth}
                popperModifiers={popperModifiers}
                locale={lang}
              />
            }
            {!props.hideSearch && 
              <button className="btn btn-primary btn-search" onClick={() => props.onChange(inputStartValue, inputEndValue)}>
                <i aria-hidden="true" role="presentation" className="fa fa-search me-2"></i>
                <FormattedMessage id="button.fetch"/>
              </button>
            }
          </div>
        </div>
      </>
    );
};